// import React from "react";
// import StyledTooltip from "../../common/StyledTooltip";

// export default function StageWiseAnalysisCards({ stages }) {
//   const cards = (stages || []).map((stage) => ({
//     title: stage.stageLabel,
//     borderColor: stage.stageKey === 1
//       ? "#3B82F6"
//       : stage.stageKey === 2
//       ? "#10B981"
//       : "#F59E0B",
//     values: [
//       { label: "Active Loans", value: stage.activeLoans?.toLocaleString() || "0" },
//       {
//         label: "Collection Amount",
//         value: `₹${(stage.collectionAmount / 100000).toFixed(2)}L`,
//         originalValue: stage.collectionAmount || 0,
//         highlight: true,
//       },
//       {
//         label: "Collection Rate",
//         value: `${stage.collectionRate?.toFixed(1) || 0}%`,
//         highlight: true,
//       },
//       {
//         label: "% of Total Portfolio",
//         value: `${stage.portfolioPercentage?.toFixed(1) || 0}%`,
//       },
//     ],
//   }));

//   return (
//     <div
//       style={{
//         background: "#ffffff",
//         border: "1px solid #e5e7eb",
//         borderRadius: "14px",
//         padding: "30px 30px",
//         boxShadow: "0 2px 6px rgba(0,0,0,0.05)",
//         marginTop: "20px",
//       }}
//     >
//       <div
//         style={{
//           fontSize: "20px",
//           fontWeight: "600",
//           marginBottom: "15px",
//           color: "#0A0A0A",
//         }}
//       >
//         Stage-wise Detailed Analysis
//       </div>

//       <div
//         style={{
//           display: "grid",
//           gridTemplateColumns: "repeat(3,1fr)",
//           gap: "18px",
//         }}
//       >
//         {cards.map((card, index) => (
//           <div
//             key={index}
//             style={{
//               border: `1px solid ${card.borderColor}`,

//               borderRadius: "12px",

//               padding: "18px",

//               background: "#fff",
//             }}
//           >
//             <p
//               style={{
//                 color: card.borderColor,
//                 fontWeight: "700",
//                 marginBottom: "12px",
//                 fontSize: "18px",
//               }}
//             >
//               {card.title}
//             </p>

//             {card.values.map((item, i) => (
//               <div
//                 key={i}
//                 style={{
//                   marginBottom: "10px",
//                 }}
//               >
//                 <p
//                   style={{
//                     fontSize: "14px",
//                     color: "#4A5565",
//                     fontWeight: "400",
//                     marginBottom: "4px",
//                   }}
//                 >
//                   {item.label}
//                 </p>

//                 {item.originalValue ? (
//                   <StyledTooltip value={item.originalValue}>
//                     <h5
//                       style={{
//                         fontSize: "24px",
//                         fontWeight: "700",

//                         color: item.highlight ? "#00A63E" : "#0A0A0A",
//                       }}
//                     >
//                       {item.value}
//                     </h5>
//                   </StyledTooltip>
//                 ) : (
//                   <h5
//                     style={{
//                       fontSize: "24px",
//                       fontWeight: "700",

//                       color: item.highlight ? "#00A63E" : "#0A0A0A",
//                     }}
//                   >
//                     {item.value}
//                   </h5>
//                 )}
//               </div>
//             ))}
//           </div>
//         ))}
//       </div>
//     </div>
//   );
// }

// // import React from "react";

// // export default function StageWiseAnalysisCards() {
// //   const cards = [
// //     {
// //       title: "1 EMI",
// //       borderColor: "#3B82F6",

// //       values: [
// //         {
// //           label: "Active Loans",
// //           value: "92",
// //           valueColor: "#0A0A0A",
// //         },

// //         {
// //           label: "Collection Amount",
// //           value: "₹92.00L",
// //           valueColor: "#059669",
// //         },

// //         {
// //           label: "Collection Rate",
// //           value: "100%",
// //           valueColor: "#2563eb",
// //         },

// //         {
// //           label: "% of Total Portfolio",
// //           value: "55.8%",
// //           valueColor: "#7c3aed",
// //         },
// //       ],
// //     },

// //     {
// //       title: "2 EMI",
// //       borderColor: "#10B981",

// //       values: [
// //         {
// //           label: "Active Loans",
// //           value: "50",
// //           valueColor: "#0A0A0A",
// //         },

// //         {
// //           label: "Collection Amount",
// //           value: "₹75.00L",
// //           valueColor: "#059669",
// //         },

// //         {
// //           label: "Collection Rate",
// //           value: "150%",
// //           valueColor: "#2563eb",
// //         },

// //         {
// //           label: "% of Total Portfolio",
// //           value: "30.3%",
// //           valueColor: "#7c3aed",
// //         },
// //       ],
// //     },

// //     {
// //       title: "3+ EMI",
// //       borderColor: "#F59E0B",

// //       values: [
// //         {
// //           label: "Active Loans",
// //           value: "23",
// //           valueColor: "",
// //         },

// //         {
// //           label: "Collection Amount",
// //           value: "₹32.00L",
// //           valueColor: "#059669",
// //         },

// //         {
// //           label: "Collection Rate",
// //           value: "139%",
// //           valueColor: "#2563eb",
// //         },

// //         {
// //           label: "% of Total Portfolio",
// //           value: "13.9%",
// //           valueColor: "#7c3aed",
// //         },
// //       ],
// //     },
// //   ];

// //   return (
// //     <div
// //       style={{
// //         background: "#ffffff",
// //         border: "1px solid #e5e7eb",
// //         borderRadius: "14px",
// //         padding: "26px",
// //         boxShadow: "0 4px 12px rgba(0,0,0,0.04)",
// //         marginTop: "20px",
// //       }}
// //     >
// //       <div
// //         style={{
// //           fontSize: "18px",
// //           fontWeight: "600",
// //           marginBottom: "20px",
// //           color: "#0f172a",
// //         }}
// //       >
// //         Stage-wise Detailed Analysis
// //       </div>

// //       <div
// //         style={{
// //           display: "grid",
// //           gridTemplateColumns: "repeat(3,1fr)",
// //           gap: "18px",
// //         }}
// //       >
// //         {cards.map((card, index) => (
// //           <div
// //             key={index}
// //             style={{
// //               border: `1px solid ${card.borderColor}`,
// //               borderTop: `4px solid ${card.borderColor}`,
// //               borderRadius: "12px",
// //               padding: "18px",
// //               background: "#fff",
// //               transition: "0.2s",
// //             }}
// //           >
// //             <div
// //               style={{
// //                 fontWeight: "600",
// //                 color: card.borderColor,
// //                 marginBottom: "14px",
// //                 fontSize: "16px",
// //               }}
// //             >
// //               {card.title}
// //             </div>

// //             {card.values.map((item, i) => (
// //               <div
// //                 key={i}
// //                 style={{
// //                   paddingBottom: "12px",
// //                   marginBottom: "12px",
// //                   borderBottom:
// //                     i !== card.values.length - 1 ? "1px solid #f1f5f9" : "none",
// //                 }}
// //               >
// //                 <div
// //                   style={{
// //                     fontSize: "13px",
// //                     color: "#64748b",
// //                     marginBottom: "4px",
// //                   }}
// //                 >
// //                   {item.label}
// //                 </div>

// //                 <div
// //                   style={{
// //                     fontSize: "22px",
// //                     fontWeight: "700",
// //                     color: item.valueColor,
// //                   }}
// //                 >
// //                   {item.value}
// //                 </div>
// //               </div>
// //             ))}
// //           </div>
// //         ))}
// //       </div>
// //     </div>
// //   );
// // }

import React from "react";
import StyledTooltip from "../../common/StyledTooltip";

const shimmerCSS = `@keyframes shimmer{0%{background-position:-600px 0}100%{background-position:600px 0}}`;
const SkBox = ({ w, h, style = {} }) => (
  <div style={{
    width: w, height: h, borderRadius: "6px",
    background: "linear-gradient(90deg,#f0f0f0 25%,#e0e0e0 50%,#f0f0f0 75%)",
    backgroundSize: "600px 100%",
    animation: "shimmer 1.4s infinite linear",
    ...style,
  }} />
);

const SKELETON_BORDERS = ["#3B82F6", "#10B981", "#F59E0B"];

export default function StageWiseAnalysisCards({ stages, loading = false }) {
  const cards = (stages || []).map((stage) => ({
    title: stage.stageLabel,
    borderColor: stage.stageKey === 1 ? "#3B82F6" : stage.stageKey === 2 ? "#10B981" : "#F59E0B",
    values: [
      { label: "Active Loans", value: stage.activeLoans?.toLocaleString() || "0" },
      { label: "Collection Amount", value: `₹${(stage.collectionAmount / 100000).toFixed(2)}L`, originalValue: stage.collectionAmount || 0, highlight: true },
      { label: "Collection Rate", value: `${stage.collectionRate?.toFixed(1) || 0}%`, highlight: true },
      { label: "% of Total Portfolio", value: `${stage.portfolioPercentage?.toFixed(1) || 0}%` },
    ],
  }));

  return (
    <>
      <style>{shimmerCSS}</style>
      <div style={{ background: "#ffffff", border: "1px solid #e5e7eb", borderRadius: "14px", padding: "30px", boxShadow: "0 2px 6px rgba(0,0,0,0.05)", marginTop: "20px" }}>
        {loading ? (
          <SkBox w="220px" h="20px" style={{ marginBottom: "18px", background: "linear-gradient(90deg,#f0f0f0 25%,#e0e0e0 50%,#f0f0f0 75%)" }} />
        ) : (
          <div style={{ fontSize: "20px", fontWeight: "600", marginBottom: "15px", color: "#0A0A0A" }}>
            Stage-wise Detailed Analysis
          </div>
        )}

        <div style={{ display: "grid", gridTemplateColumns: "repeat(3,1fr)", gap: "18px" }}>
          {loading
            ? SKELETON_BORDERS.map((color, i) => (
                <div key={i} style={{ border: `1px solid ${color}`, borderRadius: "12px", padding: "18px", background: "#fff" }}>
                  <SkBox w="70px" h="16px" style={{ marginBottom: "16px" }} />
                  {[1, 2, 3, 4].map(j => (
                    <div key={j} style={{ marginBottom: "12px" }}>
                      <SkBox w="100px" h="12px" style={{ marginBottom: "6px" }} />
                      <SkBox w="80px" h="24px" style={{ borderRadius: "4px" }} />
                    </div>
                  ))}
                </div>
              ))
            : cards.map((card, index) => (
                <div key={index} style={{ border: `1px solid ${card.borderColor}`, borderRadius: "12px", padding: "18px", background: "#fff" }}>
                  <p style={{ color: card.borderColor, fontWeight: "700", marginBottom: "12px", fontSize: "18px" }}>{card.title}</p>
                  {card.values.map((item, i) => (
                    <div key={i} style={{ marginBottom: "10px" }}>
                      <p style={{ fontSize: "14px", color: "#4A5565", fontWeight: "400", marginBottom: "4px" }}>{item.label}</p>
                      {item.originalValue ? (
                        <StyledTooltip value={item.originalValue}>
                          <h5 style={{ fontSize: "24px", fontWeight: "700", color: item.highlight ? "#00A63E" : "#0A0A0A" }}>{item.value}</h5>
                        </StyledTooltip>
                      ) : (
                        <h5 style={{ fontSize: "24px", fontWeight: "700", color: item.highlight ? "#00A63E" : "#0A0A0A" }}>{item.value}</h5>
                      )}
                    </div>
                  ))}
                </div>
              ))
          }
        </div>
      </div>
    </>
  );
}
